import { Injectable } from '@angular/core';

import { Loading } from '@app/shared/models/loading.model';

@Injectable({
  providedIn: 'root'
})
export class GerenciarAgendamentoService {

  agendamento: any;
  carregando = new Loading();
  status: String;

  atualizarStatus(status: any): void {
    this.status = status;
  }

}
